import axios from 'axios';
import _ from 'lodash';
import { getMultisiteAccessQuery, getUsersQuery, getProducersQuery, getHaulingCompaniesQuery, getProcessorsQuery, getProducerBusinessesQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { resolveId } from '../../utils';
import Split from '../split';

const wrapAccessListError = (error) => {
    const message = error?.response?.status === 401 ? 'User credentials are not correct' : 'Unable to load access list';
    const wrappedError = new Error(message);
    wrappedError.cause = error;
    wrappedError.response = error?.response;
    return wrappedError;
};

const normalizeUsers = (data) => (Array.isArray(data) ? data.map(resolveId) : []);

const getAccessList = (id, role, filterInactive = false) =>
    new Promise((resolve, reject) => {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;

        if (role === 'admin') {
            const fields = ['id', 'name', 'role', 'license_number', 'hauler_number', 'status'];
            const producersQuery = getProducersQuery({ filterDeleted: true, filterInactive, fields, queryBuilder });
            const processorsQuery = getProcessorsQuery({ filterDeleted: true, filterInactive, fields, queryBuilder });
            const haulingCompaniesQuery = getHaulingCompaniesQuery({ filterDeleted: true, filterInactive, fields, queryBuilder });
            const producerBusinessQuery = getProducerBusinessesQuery({ filterDeleted: true, filterInactive, fields, queryBuilder });

            const producersRequest = axios.get(producersQuery);
            const processorsRequest = axios.get(processorsQuery);
            const haulingCompaniesRequest = axios.get(haulingCompaniesQuery);
            const producerBusinessRequest = axios.get(producerBusinessQuery);

            const requests = [producersRequest, processorsRequest, haulingCompaniesRequest, producerBusinessRequest];

            axios
                .all(requests)
                .then(
                    axios.spread((...responses) => {
                        const [producersResponse, processorsResponse, haulingCompaniesResponse, producerBusinessResponse] = responses;
                        const users = _.sortBy([...normalizeUsers(producersResponse.data), ...normalizeUsers(processorsResponse.data), ...normalizeUsers(haulingCompaniesResponse.data), ...normalizeUsers(producerBusinessResponse.data)], 'name');
                        const data = _.map(users, (user) => ({
                            id: user.id,
                            label: user.name,
                            type: user.role,
                            license_number: user.license_number,
                            hauler_number: user.hauler_number,
                            status: user.status,
                        }));
                        resolve({ accesses: data });
                    })
                )
                .catch((errors) => {
                    // eslint-disable-next-line no-console
                    console.error(errors);
                    reject(wrapAccessListError(errors));
                });
        } else {
            const accessQuery = getMultisiteAccessQuery({ id, queryBuilder });
            const accessRequest = axios.get(accessQuery);

            accessRequest
                .then((accessResponse) => {
                    const accesses = accessResponse.data;
                    const accessIds = _.uniq(_.flatten(_.map(accesses, 'access_id')));

                    const userQuery = getUsersQuery({ ids: accessIds, fields: ['id', 'name', 'role', 'license_number', 'hauler_number', 'status'], queryBuilder });
                    const userRequest = axios.get(userQuery);

                    userRequest
                        .then((userResponse) => {
                            const users = normalizeUsers(userResponse.data);
                            const data = _.map(users, (user) => ({
                                id: user.id,
                                label: user.name,
                                type: user.role,
                                license_number: user.license_number,
                                hauler_number: user.hauler_number,
                                status: user.status,
                            }));
                            resolve({ accesses: data });
                        })
                        .catch((errors) => {
                            // eslint-disable-next-line no-console
                            console.error(errors);
                            reject(wrapAccessListError(errors));
                        });
                })
                .catch((errors) => {
                    // eslint-disable-next-line no-console
                    console.error(errors);
                    reject(wrapAccessListError(errors));
                });
        }
    });

export default getAccessList;
